module.exports = __webpack_public_path__ + "img/loader.c0bb2fc2.svg";